import React from "react";
import {
  GitBookBtn,
  Imgwrapper,
  MainSection,
  Text,
  Title,
  TokenTitle,
} from "./elements";
import { DarkButton, MainCol, MainContainer, MainRow } from "components/common";
import { Image } from "react-bootstrap";
import { t1, t2, t3, t4, t5, tokennomicsimg, tokennomicsimg1 } from "assets";
import { SiGitbook } from "react-icons/si";
import "animate.css/animate.min.css";
import { AnimationOnScroll } from "react-animation-on-scroll";
const TokennomicsComp = () => {
  const data = [
    {
      image: t1,
      text: "Allocation",
    },
    {
      image: t2,
      text: "Marketing",
    },
    {
      image: t3,
      text: "Liquidity Pool",
    },
    {
      image: t4,
      text: "Development",
    },
    {
      image: t5,
      text: "Airdrop & Bounty Program",
    },
    {
      image: t5,
      text: "Staking reward token",
    },
  ];

  const handleButtonClick = () => {
    window.open("https://www.gitbook.com", "_blank");
  };

  return (
    <MainSection id="tokennomics">
      <MainContainer>
        <AnimationOnScroll animateIn="animate__bounceIn">
          <Title>Tokenomics</Title>
        </AnimationOnScroll>
        <MainContainer>
          <MainRow>
            <MainCol lg={6}>
              <AnimationOnScroll animateIn="animate__fadeInLeft">
                <Imgwrapper>
                  <Image src={tokennomicsimg1} fluid />
                </Imgwrapper>
              </AnimationOnScroll>
            </MainCol>

            <MainCol lg={6} className="data">
              <AnimationOnScroll animateIn="animate__fadeInRight">
                <div>
                  <TokenTitle>Token Distribution</TokenTitle>
                  {data.map((item) => (
                    <div className="d-flex gap-3 align-items-center mt-4">
                      <Image src={item.image} fluid />
                      <Text>{item.text}</Text>
                    </div>
                  ))}
                  <div className="btn-div">
                    <DarkButton btnText="Tokenomics" />
                  </div>
                </div>
              </AnimationOnScroll>
            </MainCol>
          </MainRow>
        </MainContainer>
      </MainContainer>
    </MainSection>
  );
};

export default TokennomicsComp;
